import React, { Component } from 'react';
import { isEmpty, find, uniqBy } from 'lodash';

import  {
    IconButton,
    FormHelperText,
    Grid,
    Box,
    Typography,
    Avatar,
    Alert,
} from '@mui/material';

import Currency from '../../common/Currency';
import { MONTHS } from '../../../utils/generalFuncs';
import Creatable from '../../common/Creatable';
import InputText from '../../common/Form';
import { CloseRounded } from '@mui/icons-material';

export const REGEXINT = /^[1-9]\d*$/
class EquipDemandLineForm extends Component {
    state = { }

    // handleChange = (e) => {
    //     const { name, value } = e.target;
    //     this.props.handleChange(name, value , this.props.index) 
    // }

    handleChange = (e) => {
        const { name, value } = e.target;

        if(name === "line_quantity"){
            if(REGEXINT.test(value) || value === ""){
                this.props.handleChange(name, value , this.props.index)
            }
        } else {
            this.props.handleChange(name, value , this.props.index)
        }
    }
    handleChangeCreatable = (option, name) => {
        this.props.handleChangeCreatable(option, name, this.props.index)
    }
    deleteLine = (e) => {
        this.props.deleteLine(this.props.index)
    }

    render() {
        const { index, EQUIPEMENTS, demand, errors, selected} = this.props;
        let background = (index % 2 === 0) ? "" : "#f1f4f7";
        let equipement = this.props.line_equipement ? find(EQUIPEMENTS, {duplicate_from: this.props.line_equipement}) : null
        console.log('====================================');
        console.log({equipement});
        console.log('====================================');
        return (
            <div>
                {index != 0 && <hr/> }
                <div style={{background, padding: "15px", marginBottom: "15px" }}>
                    <Box style={{display: "flex", alignItems:"center"}}>
                        <IconButton onClick={this.deleteLine}>
                            <CloseRounded color="error" />
                        </IconButton>
                        <Typography variant="button">Equipement {index + 1}</Typography>
                    </Box>
                     
                <Grid container>
                    <Grid item xs={12} sm={8} container style={{ alignItems: "center"}}>
                        {/* <Grid item sm={1} >
                        </Grid> */}
                        <Grid item md={10} xs={9}>
                            {/* <Box style={{display: "flex"}}> */}
                                {/* <IconButton onClick={this.deleteLine}>
                                    <CloseRounded color="error" />
                                </IconButton> */}
                                {EQUIPEMENTS &&
                                    <Creatable
                                        required
                                        error={errors.line_equipement}
                                        label="Equipement"
                                        onChange={(option) => this.handleChangeCreatable(option, "line_equipement")}
                                        name="line_equipement" 
                                        id="line_equipement"
                                        options={
                                            uniqBy(Object.values(EQUIPEMENTS), "equipement_original_name").map( item => ({
                                            // Object.values(EQUIPEMENTS).map( (item, i) => ({
                                                value: item.duplicate_from, 
                                                label: `${item.equipement_original_name} | ${item.equipement_brand}`,
                                                disabled: selected.includes(item.duplicate_from),
                                                nb_dispo: item.nb_dispo,
                                            }
                                        ))}
                                        helperText={equipement && `Quantité disponible: ${equipement.nb_dispo}`}
                                        value={this.props.line_equipementDisplay || {value:"", label:""}}
                                    />

                                }
                            {/* </Box> */}
                        </Grid>

                        <Grid item md={2} xs={3}>
                            <InputText
                                onChange={this.handleChange}
                                required
                                id="line_quantity"
                                error={errors.line_quantity}
                                value={this.props.line_quantity}
                                name="line_quantity"
                                label="Qté"
                                // type="number"    
                                helperText={equipement && " "}                          
                                // helperText={equipement && `Dispo : ${equipement.nb_dispo}`}                          
                            />
                            
                        </Grid>
                        <Grid item xs={12}>
                            <InputText
                                onChange={this.handleChange}
                                id="line_remarks"
                                error={errors.line_remarks}
                                value={this.props.line_remarks}
                                name="line_remarks"
                                label="Remarques"
                                multiline
                                // rows={2}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={4} >
                        {!isEmpty(equipement) && !isEmpty(equipement.photo) &&
                            <>
                                <Box style={{ textAlign: "center"}}>
                                    <img 
                                        style={{height: "150px"}}
                                        alt={equipement.equipement_original_name} 
                                        src={`/photos/single/${equipement.photo.filename}`} 
                                    />
                                </Box>
                                {/* {equipement.equipement_remarks &&
                                    <Box>
                                        <Alert severity="info">{equipement.equipement_remarks}</Alert>
                                    </Box>
                                } */}
                            </>
                        }
                    </Grid>
                </Grid>
                </div>                
            </div>
        );
    }
}


export default EquipDemandLineForm 